import script from "./InvestHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvestHero.vue?vue&type=script&lang=ts&setup=true"

import "./InvestHero.vue?vue&type=style&index=0&id=73369610&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73369610"]])

export default __exports__